import { render, staticRenderFns } from "./scroll_product.vue?vue&type=template&id=5347f353&scoped=true"
import script from "./scroll_product.vue?vue&type=script&lang=js"
export * from "./scroll_product.vue?vue&type=script&lang=js"
import style0 from "./scroll_product.vue?vue&type=style&index=0&id=5347f353&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5347f353",
  null
  
)

export default component.exports